function parseSettings(settings) {
  let parsedSettings = settings;

  if (typeof settings === 'string') {
    try {
      parsedSettings = JSON.parse(settings);
    } catch {
      return settings;
    }
  }

  const serializedSettings = JSON.stringify(parsedSettings);

  return serializedSettings === undefined ? parsedSettings : JSON.parse(serializedSettings);
}

function settingsMatch(left, right) {
  if (left === right) return true;
  if (!left || !right || typeof left !== 'object' || typeof right !== 'object') return false;
  if (Array.isArray(left) !== Array.isArray(right)) return false;

  const leftKeys = Object.keys(left);
  const rightKeys = Object.keys(right);

  return leftKeys.length === rightKeys.length && leftKeys.every(key => (
    Object.prototype.hasOwnProperty.call(right, key) && settingsMatch(left[key], right[key])
  ));
}

export function findMatchingProfileContainers(profile, containerTypeId, settings) {
  const targetSettings = parseSettings(settings);

  return profile.containers?.filter(container => {
    if (container.container_type_id !== containerTypeId) return false;

    const containerSettings = parseSettings(container.options);

    if (containerTypeId === 'Operational Forecast') {
      const containerForecastId = containerSettings?.forecastId;
      const targetForecastId = targetSettings?.forecastId;

      return containerForecastId != null && targetForecastId != null && String(containerForecastId) === String(targetForecastId);
    }

    return settingsMatch(containerSettings, targetSettings);
  }) || [];
}

export function findMatchingProfileContainer(profile, containerTypeId, settings) {
  return findMatchingProfileContainers(profile, containerTypeId, settings)[0];
}
